import React from 'react';

import { EventFrame } from '@vlabs/monokit/entities/events/event-frame/EventFrame.point3';
import { EventTopMatchHistoryPoint3 } from '@vlabs/monokit/entities/events/event-top-match-history/EventTopMatchHistory.point3';
import { EventMapPoint3 } from '@vlabs/monokit/entities/events/map/EventMap.point3';
import { EventTopMatchPanel } from '@vlabs/monokit/widgets/event-top-match-panel/EventTopMatchPanel.point3';

import st from './DetectionAndMatchEventView.module.sass';
import { useSelectedWorkspaceEvent } from '../useSelectedWorkspaceEvent';

export function DetectionAndMatchEventView(): React.JSX.Element {
  const { setSelectedEvent, event } = useSelectedWorkspaceEvent();

  const onEventSelect = (historyEvent) => {
    setSelectedEvent(historyEvent);
  };

  return (
    <div className={st.EventInfo}>
      <EventFrame event={event} />
      <EventMapPoint3 event={event} />
      <EventTopMatchPanel event={event} />
      <EventTopMatchHistoryPoint3
        event={event}
        onEventSelect={onEventSelect}
      />
    </div>
  );
}
